<script context="module">
  import {PATTERNS} from '@/const';

  function validatePassword(value, LG, lang) {
    if (value === null) {
      return null;
    }
    if (PATTERNS.PASSWORD.test(value)) {
      return null;
    }
    if (value) {
      return LG(lang.PasswordError);
    }
    return LG(lang.NoPasswordError);
  }

  function validateConfirmPassword(value, password, LG, lang) {
    if (value === null) {
      return null;
    }
    if (value) {
      if (value !== password) {
        return LG(lang.RePasswordError);
      }
      return null;
    }
    return LG(lang.NoPasswordError);
  }
</script>

<script>
  import {onMount, createEventDispatcher} from 'svelte';
  import {mc} from '@/core';
  import {Button, DrawerModal} from '@/widgets';
  import {userApi} from '@/api';
  import lang from '../RegisterLandingPage.lang';

  export let LG = null;
  export let newPasswordData = null;

  const dispatch = createEventDispatcher();

  let isLoading = false;
  let password = null;
  let confirmPassword = null;
  let errorPasswordMsg = null;
  let code = '';
  let errorConfirmPasswordMsg = null;
  let isSeeNewPassword = false;
  let isSeeConfirmPassword = false;

  $: errorPasswordMsg = validatePassword(password, LG, lang);
  $: errorConfirmPasswordMsg = validateConfirmPassword(confirmPassword, password, LG, lang);

  onMount(() => {
    code = newPasswordData.code;
  });

  function handleClickClose() {
    resetData();
    dispatch('close');
  }

  async function onConfirmPassword() {
    password = password || '';
    confirmPassword = confirmPassword || '';
    if (password && confirmPassword && !errorPasswordMsg && !errorConfirmPasswordMsg) {
      isLoading = true;
      const query = {code};
      const params = {password};
      const {data, error} = await userApi.confirmResetPassword(query, params);
      if (data) {
        mc.send('toast', 'info', {message: LG(lang.PasswordHasReset)});
        handleClickClose();
      }
      if (error) {
        mc.send('toast', 'error', error);
      }
      isLoading = false;
    }
  }

  function handleEnterKey(e) {
    if (e.keyCode === 13) {
      onConfirmPassword();
    }
  }

  function handleSeeNewPasswordClick() {
    isSeeNewPassword = !isSeeNewPassword;
  }

  function handleSeeConfirmPasswordClick() {
    isSeeConfirmPassword = !isSeeConfirmPassword;
  }

  function resetData() {
    isLoading = false;
    password = null;
    confirmPassword = null;
    errorPasswordMsg = null;
    code = '';
  }

  function handleBlurFun() {
    errorPasswordMsg = validatePassword(password, LG, lang);
  }
</script>

<style>
  .wrap {
    height: 100%;
  }
  .close-btn {
    margin-left: auto;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    background: #eff2f7;
  }
  .close-btn:hover .iconfont {
    color: var(--T2);
  }
  .title {
    margin-top: 70px;
    font-size: 48px;
  }
  .sub-title {
    margin-top: 80px;
  }
  .ipt-box {
    border: 1px solid #dbdfe7;
    border-radius: 4px;
    padding: 0 18px;
    height: 48px;
  }
  .ipt-box.error {
    border: 1px solid #f66;
  }
  .ipt-box:focus-within,
  .ipt-box:hover {
    border: 1px solid #003fe6;
  }
  .ipt {
    border: none;
    height: 90%;
    outline: none;
  }
  .mt50 {
    margin-top: 50px;
  }
  .disabled {
    background: #fafafa;
  }
</style>

<DrawerModal visible>
  <div class="wrap pr">
    <div class="close-btn df aic jcc cp" on:click={handleClickClose}>
      <i class="iconfont f30 T4">&#xe614;</i>
    </div>
    <div class="form">
      <div class="title">{LG(lang.NewPassword)}</div>
      <div class="sub-title T4">{LG(lang.EnterYourNew)}</div>
      <div class="ipt-box df aic mt20" class:disabled={isLoading} class:error={errorPasswordMsg}>
        <i class="iconfont T4">&#xe644;</i>
        {#if isSeeNewPassword}
          <input class="autofill ml12 ipt f1" type="text" placeholder={LG(lang.NewPassword)} bind:value={password} disabled={isLoading} on:keypress={handleEnterKey} on:blur={handleBlurFun} />
        {:else}
          <input class="autofill ml12 ipt f1" type="password" placeholder={LG(lang.NewPassword)} bind:value={password} disabled={isLoading} on:keypress={handleEnterKey} on:blur={handleBlurFun} />
        {/if}
        <i class="iconfont T4 cp" on:click={handleSeeNewPasswordClick}>{@html isSeeNewPassword ? '&#xe66a;' : '&#xe669;'}</i>
      </div>
      {#if errorPasswordMsg}
        <div class="correct mt10">{errorPasswordMsg}</div>
      {/if}
      <div class="ipt-box df aic mt16" class:disabled={isLoading} class:error={errorConfirmPasswordMsg}>
        <i class="iconfont T4">&#xe644;</i>
        {#if isSeeConfirmPassword}
          <input class="autofill ml12 ipt f1" type="text" placeholder={LG(lang.ConfirmNewPassword)} bind:value={confirmPassword} disabled={isLoading} on:keypress={handleEnterKey} />
        {:else}
          <input class="autofill ml12 ipt f1" type="password" placeholder={LG(lang.ConfirmNewPassword)} bind:value={confirmPassword} disabled={isLoading} on:keypress={handleEnterKey} />
        {/if}
        <i class="iconfont T4 cp" on:click={handleSeeConfirmPasswordClick}>{@html isSeeConfirmPassword ? '&#xe66a;' : '&#xe669;'}</i>
      </div>
      {#if errorConfirmPasswordMsg}
        <div class="correct mt10">{errorConfirmPasswordMsg}</div>
      {/if}
      <div class="mt50">
        <Button minWidth="100%" type="primary" loading={isLoading} on:click={onConfirmPassword}>{LG(lang.Continue)}</Button>
      </div>
    </div>
  </div>
</DrawerModal>
